<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_vi"></a><a id="page_vii"></a>CONTENTS</h2>
<p class="toc1"><a href="#/xhtml/preface#eth">Ethnomusicology Multimedia Series Preface</a></p>
<p class="toc1"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="toc1"><a href="#/xhtml/translation#lan">Note on Language and Transliteration</a></p>
<p class="toc1t"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="chtoc"><span href="#/xhtml/chapter1#ch1" title="Link target outside of Sample"><strong>1</strong> Azerbaijani Musical Nationalism during the Pre-Soviet and Soviet Eras</span></p>
<p class="chtoc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample"><strong>2</strong> Pioneers of the New Azerbaijani Musical Identity</span></p>
<p class="chtoc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><strong>3</strong> The Russian-Soviet Factor: Facilitating or Disrupting Synthesis?</span></p>
<p class="chtoc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><strong>4</strong> The Beginning of the National Style: 1900–the 1930s</span></p>
<p class="chtoc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><strong>5</strong> Growing Maturity: 1940–the Early 1960s</span></p>
<p class="chtoc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><strong>6</strong> The Spirit of Experimentalism: Since the 1960s</span></p>
<p class="chtoc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><strong>7</strong> Songwriters</span></p>
<p class="chtoc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><strong>8</strong> Jazz <em>Mugham</em></span></p>
<p class="chtoc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><strong>9</strong> Leaving the Post-Soviet Era Behind</span></p>
<p class="chtoc1"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><strong>10</strong> “<em>Mugham</em> Opera” of the Silk Road</span></p>
<p class="toc1a"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1t"><span href="#/xhtml/glossary#glo" title="Link target outside of Sample">Glossary</span></p>
<p class="toc1"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f0505eee